export const getUser = (state) => state.user
export const getError = (state) => state.error
export const getSuccess = (state) => state.success
export const getSettings = (state) => state.settings
export const getTotalReport = (state) => state.totalReport
export const getUpdateReports = (state) => state.updateReports
export const showSettings = (state) => state.showSettings
export const showTaskDialog = (state) => state.showTaskDialog
export const showDetailsDialog = (state) => state.showDetailsDialog
export const getSelectedProject = (state) => state.selectedProject
export const getSelectedProjectName = (state) => state.selectedProjectName
export const getCurrentTasksList = (state) => state.currentTasksList
export const getCurrentTaskData = (state) => state.currentTaskData
export const getConfirmOrDeniedDialogModes = (state) => state.confirmOrDeniedDialogModes
export const getShowConfirmDeniedDialog = (state) => state.showConfirmDeniedDialog
export const updateTasks = (state) => state.updateTasks
export const getEmployee = (state) => state.employeeList
export const getUsersOnProject = (state) => state.usersOnProject
export const isDragging = (state) => state.dragging
export const getParentTasksInProject = (state) => state.parentTasksOnProject
export const getOverlay = (state) => state.overlay
export const getOpenedFolders = (state) => state.stateOfOpenedFolders
export const getEmployeeById = (state) => (id) => state.employee.filter(empl => empl.Employee_ID === id)[0]
export const getAllEmployee = (state) => state.employee
export const getEstRepAtTasks = (state) => state.estRepTasks
export const getStatuses = (state) => state.statuses
export const getActivityTypes = (state) => state.activityTypes
export const getPermissions = (state) => state.permissions
export const getDepartments = (state) => state.departments
export const getContractTypes = (state) => state.contract_types
export const getWorkLocations = (state) => state.work_locations
export const getClients = (state) => state.clients
export const getProjects = (state) => state.projects
export const getProjectStatuses = (state) => state.projectStatuses
export const getProjectManagementHistory = (state) => state.projectManagementHistory
export const getProjectRateHistory = (state) => state.projectRateHistory
export const getNotifications = (state) => state.notifications
export const getEmployeeRoles = (state) => state.employeeRoles
export const getEmailConfigElement = (state) => state.currentEmailConfigElement
export const getSocialIcon = (state) => state.socialIcons
export const getEmailTemplates = (state) => state.emailTemplates
export const getEmployeeNameClicked = (state) => state.employeeNameClicked
export const getPolicies = (state) => state.policies
export const getPolicyUsers = (state) => state.policyUsers
export const getBlockedProject = (state) => state.blockedProject
export const getSelectedTasks = (state) => state.selectedTasks
export const getDivisions = (state) => state.divisions
export const getInvoices = (state) => state.invoices
export const getUpdateSalary = (state) => state.updateSalary
export const getEmployeeDetails = (state) => state.employeeDetailsScreen
export const getProjectDetails = (state) => state.projectDetailsScreen
export const getClientDetails = (state) => state.clientDetailsScreen
export const showEditTaskOrFolderDialog = (state) => state.showEditTaskOrFolderDialogData.show
export const getEditTaskOrFolderDialogData = (state) => state.showEditTaskOrFolderDialogData.data
export const getAccessToCreateTasksEmplList = (state) => state.accessToCreateTasksEmplList
export const updateTask = (state) => state.updateTask
export const getDeleteAlertDialogData = (state) => state.alertAboutDeleteDialogData
export const updateReportsList = (state) => state.updateReportsList
export const getReportToUpdate = (state) => state.managerReportsState.updateReport
export const getAssetDetails = (state) => state.assetDetailsScreen
export const getProjectDetailsDialogState = (state) => state.projectDetailsDialogState
export const getCurrentUserPosition = (state) => state.employeePosition
export const getIsLoading = (state) => state.isLoading
